import { renderStatus } from "../../_utils";
import { useNavigate } from "@/router";
import TableDetailsPanel from "@/components/TableDetailsPanel";
import { Path } from "@/router";
import { Row } from "@tanstack/react-table";
import { PaymentRow } from "../types";
import { buildAvatarDetailsColumn } from "@/components/Table";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";

type OrderPayment = PaymentRow["orderPayments"][number];

export const ExpandedPaymentsRow = ({ row }: { row: Row<PaymentRow> }) => {
  const navigate = useNavigate();
  const { isCompactLayout } = useIsCompactLayout();

  const avatarColumns = buildAvatarDetailsColumn<OrderPayment>({
    isCompactLayout,
    getTitle: (order) => `${order.person.firstName} ${order.person.lastName}`,
    getSubtitle: (order) => order.person.mainProgramType?.name || "",
    getPicture: (order) => order.person.profilePhoto,
    header: "Name",
    size: 400,
    id: "fullName",
    adjustForTableDetailsPanel: true
  });

  return (
    <TableDetailsPanel
      title={`Orders (${row.original.orderPayments.length})`}
      data={row.original.orderPayments}
      onClickRow={(row) => {
        navigate(`/billing/orders/${row.original.id}?return_to=/billing/payments` as Path);
      }}
      columns={[
        ...avatarColumns,
        { accessorKey: "pgaId", header: "PGA ID", size: 150, enableSorting: false },
        {
          accessorKey: "description",
          header: "Description",
          size: 300,
          enableSorting: false,
          meta: { headerClassName: "hide-header-in-column" }
        },
        {
          accessorKey: "products",
          header: "Products",
          size: 150,
          enableSorting: false,
          cell: ({ row }) => row.original.lineItems.length + row.original.addons.length
        },
        { accessorKey: "netPayment", header: "Net Payment", size: 300, enableSorting: false },
        {
          accessorKey: "stage",
          header: "Stage",
          size: 300,
          enableSorting: false,
          meta: {
            headerClassName: "hide-header-in-column"
          },
          cell: ({ row }) => renderStatus(row.original.stage, row.original.paymentStatus)
        }
      ]}
    />
  );
};
